export default "__VITE_ASSET__Sq38wZJ7__"